import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import React from "react";
import "../../Sass/Common.scss";
// import { PrimaryDialogTitle } from "..DialogComponents";
import { ReactComponent as DeleteRoundIcon } from "../../Assets/Icons/DeleteRoundIcon.svg";
//import { ReactComponent as Urgent } from "../../Assets/Icons/Urgent.svg";
import { makeStyles } from "@mui/styles";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { PrimaryDialogTitle } from "./Dialog/DialogComponents";

const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {},
  },
  textAlign: {
    textAlign: "center",
    "&>h3": {
      color: "black !important",
      fontWeight: "500 !important",
    },
    "&>h4": {
      fontSize: "20px !important",
      padding: "5px",
      color: "black !important",
      fontWeight: "400 !important",
    },
  },
}));

const ContactUsDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    title = "",
    body,
    actionBtnTitle = "",
    handleSubmit = () => {},
    loading = false,
    subTitle,
    warning,
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        maxWidth={"xs"}
        open={open}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <PrimaryDialogTitle handleClose={handleClose} />
        <Box className={classes.resConfirmationBox}>
          <DialogContent>
            <Box className={classes.textAlign}>
              <Typography variant="h3">Contact:</Typography>
              <Typography variant="h4">07591402622</Typography>
              <Typography variant="h4">repeatsmart@pharmsmart.co.uk</Typography>
            </Box>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};

export default ContactUsDialog;
